import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import translationReducer from '../features/translation/translationSlice';
import mediaReducer from '../features/media/MediaSlice';
import mediaResistanceReducer from '../features/media-resistance/MediaResistanceSlice';
import materialCategoryReducer from '../features/materialCategory/MaterialCategorySlice';
import materialReducer from '../features/material/MaterialSlice';
import resistanceTypeReducer from '../features/resistanceType/ResistanceTypeSlice';
import filterReducer from '../features/filter/filterSlice';

export const store = configureStore({
  reducer: {
    translation: translationReducer,
    mediaResistances: mediaResistanceReducer,
    materialCategories: materialCategoryReducer,
    medias: mediaReducer,
    materials: materialReducer,
    resistanceTypes: resistanceTypeReducer,
    filter: filterReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
